<template>
  <button
    class="algolia-active-value-tag"
    type="button"
  >
    <span
      class="algolia-facet__value--key text-body-2xs"
      :class="{ 'size-value': refinement.attribute === 'sizes' }"
      v-text="value"
    />

    <span class="algolia-active-value-tag__close">
      <span
        class="visually-hidden"
        v-text="$string('accessibility.close')"
      />

      <icon-close />
    </span>
  </button>
</template>

<script>

/**
 * Vue: Algolia active value tag (main-collection)
 * -----------------------------------------------------------------------------
 * Tag shown under collection filters with active value.
 * Click event handler is added to the component directly.
 *
 * @param {Object} refinement - algolia refinement.
 *
 */
import IconClose from '~icons/misc/close.svg'

export default {
  name: 'AlgoliaActiveValueTag',

  components: {
    IconClose,
  },

  props: {
    refinement: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    value() {
      const { attribute, label, value } = this.refinement

      /**
       * Formats colour labels.
       */
      if (attribute === 'colour') {
        const valueParts = label.split('-')

        if (valueParts.length <= 2 && valueParts.length){
          return valueParts[0]
        } else if (valueParts.length > 2) {
          return `${valueParts[0]}/${valueParts[2]}`
        }
      }

      if (attribute.includes('price')) {
        return label.replace(value, `${this.$variable('store.currencySymbol')}${value}`)
      }

      return label
    },
  },
}
</script>
